export default "__VITE_ASSET__86446759__"